package com.parmartechnologies.commerce.feature

import kotlinx.serialization.json.Json

val jsonDecoder = Json {
    encodeDefaults = true
    ignoreUnknownKeys = true
    isLenient = true
}


